import React from 'react'

import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'

import { P, Text } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'

interface InfoTooltipProps {
  placement?: 'top' | 'bottom' | 'left' | 'right'
  tooltip_info_body: string
  tooltip_info_title: string
}

interface TooltipContentProps {
  body: string
  title: string
}

const TooltipContent: React.FC<TooltipContentProps> = ({ body, title }) => (
  <Stack sx={{ gap: 4, p: 12 }}>
    <Text bold={true} variant="body1">
      {title}
    </Text>
    <P variant="subtitle2">{body}</P>
  </Stack>
)

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  placement = 'bottom',
  tooltip_info_body,
  tooltip_info_title,
}) => (
  <Tooltip
    enterTouchDelay={500}
    placement={placement}
    title={<TooltipContent body={tooltip_info_body} title={tooltip_info_title} />}
  >
    <IconButton aria-label={tooltip_info_title} sx={{ minHeight: 0, minWidth: 0, p: 0 }}>
      <Icon name="info" sx={{ color: 'info.main' }} />
    </IconButton>
  </Tooltip>
)

export default InfoTooltip
